import ProductDetails, { ProductDetailsProps } from './ProductDetails'

export default ProductDetails

export type { ProductDetailsProps }
